<template>
  <button
    type="button"
    :style="computedStyle"
    :class="[getCss('border'), getCss('text'), {'csu-clickable': clickable}]"
    @click="handleClick()"
    @mouseenter="handleEvent('hover')"
  >
    <span class="base-button-text">{{ text || configurationData.text }}</span>
  </button>
</template>
<script>
import '@tencent/ceiba-base-components/index.scss';
import { componentBaseMixin, baseComponents, common } from '@tencent/ceiba-base-components';

export default {
  name: 'CButton',

  mixins: [componentBaseMixin],
  props: {
    text: {
      type: String,
      default: '',
    }, // 优先级大于configurationData.text
  },
  data() {
    return {
      cssPrefix: 'button-',
      clickHandler: {},
      customHandler: false,
      showRiskPopup: false,
    };
  },
  computed: {
    computedStyle() {
      const bgi = this.configurationData.backgroundImage;
      const { isStretching } = this.configurationData;
      if (typeof bgi === 'string' && bgi.length > 0) {
        // 设置了背景图
        return {
          ...this.styles.base,
          backgroundImage: `url(${bgi})`,
          backgroundRepeat: 'no-repeat',
          backgroundColor: 'transparent',
          backgroundSize: isStretching ? '' : 'contain', // 是否拉伸
        };
      }
      return this.styles.base;
    },
    riskControlText() {
      return this.configurationData.riskControlText || '前往心悦微官网参与（手机浏览器打开xinyue.qq.com）';
    },
  },
  methods: {
    setClickHandler(action, {
      forceLogin = false,
      forceApp = false,
      forceRole = false,
      debug = false,
      enableGame = false,
    }) {
      this.clickHandler.action = action;
      this.clickHandler.forceLogin = forceLogin;
      this.clickHandler.forceApp = forceApp;
      this.clickHandler.forceRole = forceRole;
      this.clickHandler.enableGame = enableGame;
      this.clickHandler.debug = debug;
      this.customHandler = true;
    },
    async handleClick() {
      // APP 体系内
      if (this.configurationData.forceApp && !this.$ast.isAPP()) {
        if (common.platform.isGame && this.clickHandler.enableGame) {
          console.log('common.platform.isGame && this.clickHandler.enableGame');
        } else {
          this.$ast.gotoAPP();
          return;
        }
      }
      if (this.clickHandler && typeof this.clickHandler.action === 'function') {
        if (!this.clickHandler.debug) {
          // APP 体系内
          if (this.clickHandler.forceApp && !this.$ast.isAPP()) {
            if (common.platform.isGame && this.clickHandler.enableGame) {
              console.log('common.platform.isGame && this.clickHandler.enableGame');
            } else {
              this.$ast.gotoAPP();
              return;
            }
          }
          // 强制登陆
          if (this.clickHandler.forceLogin && !this.isLogin) {
            baseComponents.userLoginComponent.login();
            return;
          }
          console.log('this.isRoleStatusValid=', this.isRoleStatusValid, this.clickHandler.forceRole);
          if (this.clickHandler.forceRole && this.isRoleStatusValid && !this.isRoleReady) {
            const self = this;
            try {
              baseComponents.gameRoleSelect.showGameRoleSelect(this.currentGameCode, {}).then((roleInfo) => {
                console.log('store select role=', roleInfo);
                self.$store.dispatch('saveCurrentRole', {
                  isRoleReady: true,
                  roleInfo,
                });
                self.$eventBus.$emit('ceiba:common:events:bind-role');
              });
            } catch (e) {
              console.error('showGameRoleSelect fail| err=', e);
            }

            // this.alert({
            //   msg: '未检测到角色，请先绑定角色',
            //   confirm: () => {},
            // });
            return;
          }
        }

        try {
          await this.clickHandler.action();
        } catch (e) {
          console.error('clickHandler fail, err=', e);
        }
      }
      // 跳转前风控判定
      const link = this.getUrlFromEvent();
      if (link && this.riskControlFlag && this.checkUrlRuleType && this.checkUrlRuleType(link)) {
        this.$alert({ msg: this.riskControlText });
        return false;
      }
      if (!this.customHandler) this.handleClickEvent();
    },
    getUrlFromEvent() {
      const record = this?.events.find(i => i.action === 'redirectURL');
      if (!record) return '';
      const linkConfig = record.data.find(i => i.type === 'redirectURL');
      return linkConfig?.page || '';
    },

  },
};
</script>
<style lang="scss">
@import './styles.scss';
</style>
